import JobActions from './JobActions.vue'

export default JobActions
